// @flow
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Text from './Typography';
import { formatDate } from '../../utils/date-helpers';
import { getRouteTFunction } from '../../i18n';

type Props = {
  done: boolean,
  status: string,
  recordsAvailable: boolean,
  date: string,
  followup: boolean
}

const SingleStatus = ({ done, followup, recordsAvailable, date, status }: Props) => {
  const { t } = useTranslation('providerSingleStatus');
  const routesTFunction = getRouteTFunction();
  const icon = done ? 'check-filled' : 'check-unfilled';
  const iconFollowup = 'followup-flag';
  const dashboard = routesTFunction('redirectPaths./dashboard');
  const grey = 'grey';
  return (
    <Fragment>
      <Text
        icon={followup ? iconFollowup : icon}
        bold={done}
        paragraph
        color={!done && 'grey'}
      >
        {status}
      </Text>
      {recordsAvailable &&
        <Link
          className='status__link-records'
          to={dashboard}
        >{t('view_my_records')}</Link>}
      {date && <Text color={grey} icon paragraph>{formatDate(date)}</Text>}
    </Fragment>
  );
};

export default SingleStatus;



// WEBPACK FOOTER //
// ./src/components/shared/ProviderSingleStatus.js